import { Link } from "react-router-dom";
import React, { useEffect } from 'react';
import { Box, Grid, Card, CardContent, CardActionArea, Typography } from '@mui/material';
import { useBreadcrumb } from '../breadcrumb-context';
import { useAuth } from '../shared/hooks/useAuth';

export default function Index() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { hasRole } = useAuth();
  
  useEffect(() => {
    setBreadcrumbs([]);

    // Clean up function
    return () => {
      setBreadcrumbs([]);
    };
  }, [setBreadcrumbs]);

  const tileStyle = {
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: 'inherit',
  };

  return (
    <Box sx={{ p: 3, height: '100%' }}>
      <Grid container spacing={3} justifyContent="flex-start">
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ backgroundColor: '#4caf50', color: '#fff' }}>
            <CardActionArea component={Link} to="navigation/beef">
              <CardContent sx={tileStyle}>
                <img 
                  src={`${import.meta.env.VITE_VIRTUAL_DIRECTORY}/cow-64.png`}
                  alt="Beef"
                  style={{ marginBottom: 16 }}
                />
                <Typography variant="h3" component="h1">
                  Beef
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ backgroundColor: '#f44336', color: '#fff' }}>
            <CardActionArea component={Link} to="navigation/pork">
              <CardContent sx={tileStyle}>
                <img 
                  src={`${import.meta.env.VITE_VIRTUAL_DIRECTORY}/pig-64.png`}
                  alt="Pork"
                  style={{ marginBottom: 16 }}
                />
                <Typography variant="h3" component="h1">
                  Pork
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {(hasRole('LMS.Admin') || hasRole('LMS.Payables')) && (
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: '#2196f3', color: '#fff' }}>
              <CardActionArea component={Link} to="settings">
                <CardContent sx={tileStyle}>
                  <img 
                    src={`${import.meta.env.VITE_VIRTUAL_DIRECTORY}/gear-2-64.png`}
                    alt="Settings"
                    style={{ marginBottom: 16 }}
                  />
                  <Typography variant="h3" component="h1">
                    Settings
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )}

        {hasRole('LMS.Reporting') && (
          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ backgroundColor: '#673ab7', color: '#fff' }}>
              <CardActionArea component={Link} to="reports">
                <CardContent sx={tileStyle}>
                  <Typography variant="h3" component="h1">
                    Reports
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}